import { addApoFeatures } from '@actions/apo.action';
import { Action, createReducer, on } from '@ngrx/store';

export interface State {
  input_params: Record<string, string>;
}

export const INITIAL_STATE: State = {
  input_params: {},
};

const reducer = createReducer(
  INITIAL_STATE,
  on(addApoFeatures, (state, action): State => {
    return {
      ...state,
      input_params: action.features,
    };
  }),
);

export const apoReducer = (state: State, action: Action): State =>
  reducer(state, action);
